export const handleSubmissionErrors = callback => err => {
  const { body } = err.graphQLErrors[0].extensions.exception;
  Object.keys(body).forEach(key => {
    callback(`${key} ${body[key][0]}`);
  });
};
